import utils from '@/utils'

/**
 * パスワード
 */
export default (val, msg) => {
  if (utils.string.isEmpty(val)) {
    return true
  }
  if (/^(?=.*?[a-z])(?=.*?\d)[a-z\d]{8,}$/.test(val)) {
    return true
  }

  return msg
}
